export function prettyDuration(duration) {
    const hours = Math.trunc(duration / 60);
    const minutes = duration - hours * 60;

    return { hours, minutes };
}
